import React, { useContext, useState } from "react";
import { Request } from "../../api/customers/Customer.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import Success from "../../components/Success";
import { useTranslation } from "react-i18next";

const DeleteCustomerContainer = ({ customer, onClose, children }) => {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);
  const [success, setSuccess] = useState(false);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);

    Request.deleteCustomer(token.access, values.id)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    setLoading(false);
    setSuccess(true);
    actions?.setSubmitting(false);
  };

  const onFailure = (error) => {
    console.log("error", error);

    if (error?.response?.data?.error?.code === 40007) {
      setError({ message: error?.response?.data?.error?.localized_error });
    } else {
      setError(error);
    }
    setLoading(false);
  };
  const onCloseSuccesPopup = () => {
    setSuccess(null);
    onClose();
  };

  return (
    <>
      {error ? (
        <Error message={error} onClose={() => onCloseSuccesPopup()} />
      ) : null}
      {loading ? <Loading /> : loading}
      {success ? (
        <Success
          message={t("delete_customer.success_text")}
          onClose={() => onCloseSuccesPopup()}
        />
      ) : null}
      {customer ? children({ onSubmit, customer }) : null}
    </>
  );
};

export default DeleteCustomerContainer;
